import { StringifyOptions } from "query-string";

export const stringifyConfig: StringifyOptions = {
  arrayFormat: "bracket",
  skipNull: true,
  skipEmptyString: true,
};
